module.exports = __webpack_public_path__ + "img/boolando.96e02a23.png";